export const HUEVOS_POR_MAPLE = 30;

export interface GranjaCantidadEntrada {
  lote: string;
  maples: number;
  huevos?: number;
}

export function maplesYHuevosAUnidades(
  maples: number,
  huevos = 0,
  huevosPorMaple = HUEVOS_POR_MAPLE,
): number {
  const m = Number(maples) || 0;
  const h = Number(huevos) || 0;
  if (huevosPorMaple <= 0) return m;
  return m + h / huevosPorMaple;
}

export function unidadesAMaplesYHuevos(
  unidades: number,
  huevosPorMaple = HUEVOS_POR_MAPLE,
): { maples: number; huevos: number } {
  const u = Math.max(0, Number(unidades) || 0);
  if (huevosPorMaple <= 0) return { maples: u, huevos: 0 };
  const maples = Math.floor(u + 1e-9);
  const frac = u - maples;
  const huevos = Math.round(frac * huevosPorMaple);
  return { maples, huevos };
}

export function formatMaplesYUnidades(
  unidades: number,
  huevosPorMaple = HUEVOS_POR_MAPLE,
): string {
  const { maples, huevos } = unidadesAMaplesYHuevos(unidades, huevosPorMaple);
  if (huevos <= 0) return `${maples} maples`;
  return `${maples} maples · ${huevos} u.`;
}

export function unidadesAHuevos(
  unidades: number,
  huevosPorMaple = HUEVOS_POR_MAPLE,
): number {
  return Math.round((Number(unidades) || 0) * huevosPorMaple);
}

export function maplesYHuevosAHuevos(
  maples: number,
  huevos = 0,
  huevosPorMaple = HUEVOS_POR_MAPLE,
): number {
  return Math.round(maplesYHuevosAUnidades(maples, huevos, huevosPorMaple) * huevosPorMaple);
}

export function sumarEntradas(
  entradas: GranjaCantidadEntrada[],
  huevosPorMaple = HUEVOS_POR_MAPLE,
): number {
  return (entradas ?? []).reduce(
    (acc, e) => acc + maplesYHuevosAUnidades(e.maples, e.huevos ?? 0, huevosPorMaple),
    0,
  );
}

export interface GranjaBalanceClasificacion {
  bruto: number;
  vendible: number;
  cascado: number;
  tirado: number;
}

export function balanceaClasificacion(
  bal: GranjaBalanceClasificacion,
  tolerancia = 0.0001,
): boolean {
  const total = (bal.vendible || 0) + (bal.cascado || 0) + (bal.tirado || 0);
  return Math.abs(total - (bal.bruto || 0)) <= tolerancia;
}

export function diferenciaBalance(bal: GranjaBalanceClasificacion): number {
  const total = (bal.vendible || 0) + (bal.cascado || 0) + (bal.tirado || 0);
  return (bal.bruto || 0) - total;
}
